import { useActiveClinic } from '@/lib/activeClinic';
import { QuestionnairePicker } from '@/components/questionnaires/QuestionnairePicker';
import type { QuestionnairePickerItem } from '@/lib/questionnairePickerLabel';

export function QuestionnaireMultiPicker({
  open,
  title,
  subtitle,
  items,
  lockedIds,
  showSearch = true,
  note,
  clinicId,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  subtitle?: string;
  items: QuestionnairePickerItem[];
  lockedIds?: readonly string[];
  showSearch?: boolean;
  note?: { title: string; body: string } | null;
  clinicId?: string | null;
  onClose: () => void;
  onConfirm: (ids: string[]) => void;
}) {
  const { activeClinicId } = useActiveClinic();
  return (
    <QuestionnairePicker
      open={open}
      title={title}
      subtitle={subtitle}
      items={items}
      lockedIds={lockedIds}
      showSearch={showSearch}
      note={note}
      clinicId={clinicId ?? activeClinicId}
      mode="select"
      presentation="popover"
      onClose={onClose}
      onConfirm={(payload) => {
        onConfirm(payload.ids);
        onClose();
      }}
    />
  );
}
